import {
  LOGIN,
  LOGOUT,
  AGREESMS,
  SETCONSENTDOCID,
} from '../actions/loginAction';
import { reactLocalStorage } from 'reactjs-localstorage';
import Const from '../const';

const INITIAL_STATE = {
  isLogin: false,
  loginInfo: {},
};

const loginReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOGIN:
      reactLocalStorage.setObject(
        Const.appName + '#userinfo',
        action.loginInfo
      );
      return Object.assign({}, state, {
        isLogin: true,
        loginInfo: action.loginInfo,
      });
    case LOGOUT:
      reactLocalStorage.remove(Const.appName + '#userinfo');
      return Object.assign({}, INITIAL_STATE);

    case AGREESMS:
      const loginInfo = Object.assign({}, state.loginInfo, {
        agreeSms: action.flag,
      });
      reactLocalStorage.setObject(Const.appName + '#userinfo', loginInfo);
      return Object.assign({}, state, { loginInfo: loginInfo });

    case SETCONSENTDOCID:
      const info = Object.assign({}, state.loginInfo, {
        consentDocId: action.consentDocId,
      });
      reactLocalStorage.setObject(Const.appName + '#userinfo', info);
      return Object.assign({}, state, { loginInfo: info });

    default:
      return state;
  }
};

export default loginReducer;
